import type { Style } from "../types";

export const STYLES: Style[] = [
  { id: "neapolitan", name: "Neapolitan",
    geometry: "ball", unitWeight: 250, unitLabel: "Ball weight (g)", countLabel: "Dough balls",
    hydration: 62, salt: 2.5, oil: 0, sugar: 0, time: 12,
    note: "Soft, wet balls fermented warm. 8–24h.",
    method: [
      "Dissolve the yeast (or starter) in half the water.",
      "Add the flour and mix to a shaggy dough, adding more of the water if it's too stiff; rest 20 min.",
      "Add the salt, then work in the rest of the water to feel until smooth.",
      "Knead 10–15 min to a soft, elastic dough; bulk ferment.",
      "Divide into balls and proof until puffy.",
      "Hand-stretch (no rolling pin) and bake as hot as the oven goes.",
    ] },
  { id: "ny", name: "New York",
    geometry: "ball", unitWeight: 340, unitLabel: "Ball weight (g)", countLabel: "Dough balls",
    hydration: 63, salt: 2, oil: 3, sugar: 1.5, time: 48,
    note: "300–400g balls for 14–16\". Cold ferment 24–72h.",
    method: [
      "Dissolve the yeast (or starter) and sugar in half the water.",
      "Mix in the flour and salt, adding the rest of the water to feel.",
      "Work in the oil, then knead until strong and smooth (windowpane).",
      "Divide into balls, lightly oil, cold-ferment in the fridge 24–72h.",
      "Warm the balls 1–2h before shaping.",
      "Stretch and bake hot on a stone or steel.",
    ] },
  { id: "sicilian", name: "Sicilian",
    geometry: "pan", unitWeight: 400, unitLabel: "Dough per pan (g)", countLabel: "Pans",
    hydration: 75, salt: 2.5, oil: 4, sugar: 1.5, time: 24,
    note: "Thick pan pizza. ~400g per 10×14\" pan.",
    method: [
      "Dissolve the yeast (or starter) and sugar in half the water.",
      "Mix in the flour, salt and oil, adding the rest of the water to feel.",
      "Stretch-and-fold a few times over the first hour.",
      "Bulk ferment, then press into a well-oiled pan.",
      "Proof in the pan until risen to the edges.",
      "Top and bake hot until deep golden underneath.",
    ] },
  { id: "grandma", name: "Grandma",
    geometry: "pan", unitWeight: 325, unitLabel: "Dough per pan (g)", countLabel: "Pans",
    hydration: 67, salt: 2, oil: 3.5, sugar: 1, time: 24,
    note: "Thin-ish pan style. ~325g per 10×14\" pan.",
    method: [
      "Dissolve the yeast (or starter) and sugar in half the water.",
      "Mix in the flour, salt and oil, adding the rest of the water to feel.",
      "Light knead to a soft dough, then bulk ferment.",
      "Press into an oiled pan and rest until relaxed and easy to spread.",
      "Dimple, top thinly, and bake hot.",
    ] },
  { id: "detroit", name: "Detroit",
    geometry: "pan", unitWeight: 275, unitLabel: "Dough per pan (g)", countLabel: "Pans",
    hydration: 72, salt: 2, oil: 4, sugar: 1.5, time: 24,
    note: "Crispy fried edges. ~275g per 8×10\" pan.",
    method: [
      "Dissolve the yeast (or starter) and sugar in half the water.",
      "Mix in the flour, salt and oil, adding the rest of the water to feel.",
      "Stretch-and-fold over the first hour to a wet, strong dough.",
      "Bulk ferment, then press into a well-oiled steel pan.",
      "Proof until light and airy.",
      "Lay cheese to the edges, stripe sauce on top, bake hot for crisp edges.",
    ] },
  { id: "roman-taglio", name: "Roman al Taglio",
    geometry: "pan", unitWeight: 275, unitLabel: "Dough per tray (g)", countLabel: "Trays",
    hydration: 80, salt: 2.5, oil: 4, sugar: 0.5, time: 48,
    note: "Very high hydration. ~275g per 30×40cm tray.",
    method: [
      "Dissolve the yeast (or starter) in half the water.",
      "Mix in the flour, salt and oil, adding the rest of the water to feel; the dough should be very wet.",
      "Several stretch-and-folds, then a long cold bulk ferment.",
      "Gently tip onto an oiled tray and coax out to the corners.",
      "Proof, top lightly, and bake hot (often par-baked first).",
    ] },
  { id: "roman-tonda", name: "Roman Tonda",
    geometry: "ball", unitWeight: 200, unitLabel: "Ball weight (g)", countLabel: "Dough balls",
    hydration: 57, salt: 2, oil: 4, sugar: 1.5, time: 24,
    note: "Thin, crisp, low hydration. 180–220g balls.",
    method: [
      "Dissolve the yeast (or starter) and sugar in half the water.",
      "Mix in the flour and salt, working in the oil; add the rest of the water sparingly to a stiff dough.",
      "Knead until smooth, then bulk ferment and divide into balls.",
      "Roll out thin (a pin is fine for this style).",
      "Bake hot until crisp and cracker-like.",
    ] },
  { id: "chicago", name: "Chicago Deep Dish",
    geometry: "pan", unitWeight: 450, unitLabel: "Dough per pan (g)", countLabel: "Pans",
    hydration: 52, salt: 1.5, oil: 12, sugar: 2, butter: 7, time: 24,
    note: "Butter/oil-rich pastry-like crust. ~450g per 12\" pan.",
    method: [
      "Dissolve the yeast (or starter) and sugar in half the water.",
      "Rub the butter and oil into the flour and salt.",
      "Add the yeasted water and mix just until it comes together, adding the rest of the water to feel; don't over-knead.",
      "Short ferment; for flake, laminate with a little butter and fold.",
      "Press up the sides of a greased deep pan.",
      "Layer cheese, then fillings, then sauce on top.",
      "Bake at a moderate heat 35–45 min until the crust is set and golden.",
    ] },
];
